export default {
  // Endpoints
  coreApiBaseUrl: process.env.VUE_APP_API_URL,
  clientTimeout: 30000,
};
